import $ from "jquery";

const loginClick = (el) => {
    const $el = $(el);

    $el.on("submit", () => {

       window._mtm.push({ event: "signIn" });

    });

};

export default loginClick;
